import VerivoxCompareClass from './../App/VerivoxCompare';
import ModalClass from './../App/Modal';
import Chart from './energySourceChart';

export default compareTariffs => {
    if ($('.compare-tariff').length < 1) {
        return false;
    }

    let VerivoxCompare = new VerivoxCompareClass();
    let maxTariffToCompare = 5;
    let $compare = $('.compare-tariffs-button');
    let $checkBoxes = $('.compare-tariff');
    let $type = $compare.data('compare-type')
    let options = {
        type: 'POST',
        url: $compare.data('compare-url'),
    };
    let modal = new ModalClass();

    VerivoxCompare.setType($type); // electricity || gas

    $checkBoxes.change(function() {
        let $checkedCheckBoxes = $('.compare-tariff:checked');
        let $uncheckedCheckBoxes = $('.compare-tariff:not(:checked)');
        if ($checkedCheckBoxes.length >= maxTariffToCompare) {
            $uncheckedCheckBoxes.attr("disabled", true);
        }
        if ($checkedCheckBoxes.length < maxTariffToCompare) {
            $uncheckedCheckBoxes.attr("disabled", false);
        }
    });

    $('.compare-column ').on('click', function (event) {
        let $target = $(event.target);

        if ($target.is('input')) {
            return;
        }

        let $checkbox = $(this).find(':checkbox');
        if ($checkbox.prop('disabled')) {
            return;
        }
        $checkbox.prop('checked', !$checkbox[0].checked);
        $checkbox.trigger('change');
    });

    $compare.on('click', (e) => {
        let compareArr = [];

        $('.compare-tariff:checked').each((key, item) => {
            let $item = $(item);

            compareArr.push({
                id: $item.data('id'),
                url: $item.data('tariff-url')
            });
        });

        if (compareArr.length < 1) {
            return e.preventDefault();
        }

        options = $.extend(options, {
            data: {
                tariffs: compareArr,
                type: $type
            }
        });

        $.ajax(options).done(request => {
            let modalHTML = VerivoxCompare.setTariffs(request.result).getModalContent();
            if (modalHTML) {
                modal.setContent(modalHTML);
                modal.open();

                let $sources = $('[id*=chart-]:not(.initialized)');
                Chart($sources);
            }
        }).fail(request => {
            console.warn(request);
        });

        return false;
    });
};
